<template>
  <div :class="[$style.root, $style.container]">
    <div :class="[$style.scrim, { [$style.scrimExpanded]: expanded }]" />

    <TransitionWrapper>
      <div v-if="showPopover">
        <ProductTourPopover
          :altText="stepData.imgAltText"
          :bodyText="stepData.bodyText"
          :class="[$style.popover, { [$style.popoverExpanded]: expanded }]"
          :headerText="stepData.headerText"
          :image="stepData.image"
          :style="[offsetStyle]"
        />

        <div :class="[$style.indicator, { [$style.indicatorExpanded]: expanded }]" />
      </div>
    </TransitionWrapper>
  </div>
</template>

<script>
import { TransitionWrapper } from '@jumpcloud/ui-components';
import { mapState } from 'vuex';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import ProductTourPopover from 'client/components/ProductTour/ProductTourPopover';
import ProductTourSteps from 'client/components/ProductTour/ProductTourSteps';

const onboardingModule = 'OnboardingModule';

export default {
  name: 'NavPanelProductTour',

  components: {
    ProductTourPopover,
    TransitionWrapper,
  },

  EventHelper,
  ProductTourSteps,

  props: {
    expanded: {
      type: Boolean,
    },
  },

  data() {
    return {
      showPopover: false,
    };
  },

  delayDuration: 100,

  computed: {
    ...mapState(onboardingModule, [
      'productTourStepIndex',
    ]),

    offsetStyle() {
      return {
        transform: `translateY(-${this.stepData.offset}%)`,
      };
    },

    stepData() {
      return this.$options.ProductTourSteps[this.productTourStepIndex];
    },
  },

  mounted() {
    this.transitionDelay();
  },

  methods: {
    transitionDelay() {
      this.showPopover = false;
      setTimeout(() => {
        this.showPopover = true;
      }, this.$options.delayDuration);
    },
  },
};
</script>

<style scoped module>
@value (max-width-small, max-width-large) from '~css/breakpoints.css';
@value (navWidth, navWidthExpanded) from '~css/layout.css';
@value (tooltipZIndex) from '~css/z-index.css';

.root {
  --indicator-offset: 3px;
  --indicator-width: var(--jc-size-2);
  --indicator-left: calc(navWidth - var(--indicator-offset));
  --indicator-left-expanded: calc(navWidthExpanded - var(--indicator-offset));
  --popover-left: calc(navWidth + var(--indicator-width) - var(--indicator-offset));
  --popover-left-expanded:
    calc(
      navWidthExpanded + var(--indicator-width) - var(--indicator-offset)
    );
}

.container {
  position: absolute;
  right: 0;
  top: 0;
  z-index: tooltipZIndex;
}

.popover {
  left: var(--popover-left);
  transition: all var(--jc-transition-duration) var(--jc-transition-function);
}

.popoverExpanded {
  left: var(--popover-left-expanded);
}

.indicator {
  border-color: transparent var(--jc-color-surface-light) transparent transparent;
  border-style: solid;
  border-width: var(--jc-size-1) var(--indicator-width) var(--jc-size-1) 0;
  height: 0;
  left: var(--indicator-left);
  position: fixed;
  transition: all var(--jc-transition-duration) var(--jc-transition-function);
  width: 0;
}

.indicatorExpanded {
  left: var(--indicator-left-expanded);
}

.scrim {
  background-color: var(--jc-scrim-background);
  bottom: 0;
  left: navWidth;
  position: fixed;
  top: 0;
  transition: all var(--jc-transition-duration) var(--jc-transition-function);
  width: calc(100% - navWidth);
}

.scrimExpanded {
  left: navWidthExpanded;
  width: calc(100% - navWidthExpanded);
}

@media (max-width: max-width-large) {
  .popoverExpanded {
    left: 6rem;
  }
}
</style>
